module.exports = __webpack_public_path__ + "proximanova-light-webfont.bee27d5f009e9cd423be.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/sherr/Desktop/bsf-website/src/assets/fonts/proximanova-light-webfont.woff
// module id = ../../../../../src/assets/fonts/proximanova-light-webfont.woff
// module chunks = 1